// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--xoyBd","text":"_103a151b99--text--YQ1lL"};